var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    enableBackground: "new 0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC43",
    d: "M34.363,46.874c0,0,6.001-0.167,7.167-1.167c1.166-1,2,0,2.833-4.5s0.5-15.833,0.5-15.833 s17.166-0.333,21.833,0.167s5,4,5,8s-0.166,14.833-0.666,18c-0.5,3.167-4.334,2.833-4.334,2.833L66.03,62.54l-10.667-7.833 c0,0-13.333,0.5-17.833-0.667S34.363,46.874,34.363,46.874z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#667BBC",
    d: "M15.53,17.04c-7.334,0.5-6.668-3.5-7.334,6c-0.666,9.5-1,17.167,0.5,20.166c1.5,3,3.167,2.834,3.167,2.834 l1.167,1v8.167l10.666-9c0,0,11,0.5,16.167-0.5s4.333,0.334,5-6.333s1-19.334-0.5-20.834s-11.333-1.5-11.333-1.5H15.53z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#131731",
    d: "M67.297,23.705H46.278v-2.767c0-3.167-2.565-5.731-5.731-5.731v-0.002H12.511 c-3.166,0.002-5.732,2.566-5.732,5.733v20.983c0,2.961,2.244,5.396,5.125,5.699v12.083l12.049-12.051h9.577v2.768 c0,3.168,2.563,5.732,5.731,5.732h16.594l12.048,12.053V56.121c2.881-0.302,5.125-2.737,5.127-5.701V29.438 C73.027,26.272,70.463,23.708,67.297,23.705z M22.708,44.653l-7.806,7.806l0.003-7.806h-2.395c-1.509-0.002-2.731-1.224-2.731-2.732 V20.938c0-1.509,1.223-2.73,2.731-2.731h28.036c1.507,0.002,2.729,1.222,2.731,2.731v20.983c-0.002,1.507-1.225,2.73-2.731,2.732 H22.708z M70.028,50.42c-0.002,1.51-1.224,2.729-2.731,2.734h-2.395v7.803l-7.806-7.805H39.261c-1.51-0.002-2.729-1.222-2.731-2.732 v-2.768h4.018c3.166,0,5.731-2.564,5.731-5.731V26.706h21.019c1.508,0.002,2.729,1.224,2.731,2.731V50.42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.69f8586827a53aa976fe2587b95e2e16.svg";
export { ForwardRef as ReactComponent };